import React from 'react';
import {List, ListItem, ListItemButton, ListItemText, Stack, Typography} from '@mui/material';

import Icon from 'presentation/icons';
import {StyledListItemIcon} from './styles';
import {OmbudsmanFormLinkProps} from './types';

export function OmbudsmanFormLink({label, buttonText, url}: OmbudsmanFormLinkProps) {
	return (
		<Stack>
			<Typography variant="body1" color="primary">
				{label}
			</Typography>
			<List disablePadding>
				<ListItem disablePadding>
					<ListItemButton
						component="a"
						href={url}
						target="_blank"
						rel="noopener noreferrer"
						disableRipple
						disableTouchRipple>
						<ListItemText primary={buttonText} />
						<StyledListItemIcon>
							<Icon name="ben-export" />
						</StyledListItemIcon>
					</ListItemButton>
				</ListItem>
			</List>
		</Stack>
	);
}
